<div class="row">
  <div class="col-sm-12 col-md-6">
    <div class="wallet-wrapper">
      <div class="icon-currency">
        <i class="icon-bitcoin"></i>
      </div>
      <div class="wallet-details">
        <dl *ngIf="btc.wallet" class="description-list">
          <dt class="text-muted">Balance</dt>
          <dd>BTC {{ btc.wallet.balance }} <span class="divider">|</span> {{ btc.wallet.balanceEur | currency: 'EUR' }}</dd>
          <dt class="text-muted">Rate</dt>
          <dd>{{ btc.wallet.rateEur | currency: 'EUR' }}</dd>
          <dt class="text-muted">Receive address</dt>
          <dd class="copy" [tooltip]="'Click to copy'" tooltipPlacement="bottom" (click)="copyToBuffer(btc.wallet.receiveAddress)">
            {{ btc.wallet.receiveAddress }}</dd>
        </dl>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-6">
    <div class="wallet-wrapper">
      <div class="icon-currency">
        <i class="icon-litecoin"></i>
      </div>
      <div class="wallet-details">
        <dl *ngIf="ltc.wallet" class="description-list">
          <dt class="text-muted">Balance</dt>
          <dd>LTC {{ ltc.wallet.balance }} <span class="divider">|</span> {{ ltc.wallet.balanceEur | currency: 'EUR' }}</dd>
          <dt class="text-muted">Rate</dt>
          <dd>{{ ltc.wallet.rateEur | currency: 'EUR' }}</dd>
          <dt class="text-muted">Receive address</dt>
          <dd class="copy" [tooltip]="'Click to copy'" tooltipPlacement="bottom" (click)="copyToBuffer(ltc.wallet.receiveAddress)">
            {{ ltc.wallet.receiveAddress }}</dd>
        </dl>
      </div>
    </div>
  </div>
</div>
